import Style from "./PlansTableStyle";
import Spinner from "../../shared/Spinner/Spinner";
import TwoButtonsModal from "../../shared/Bootstrap/TwoButtonsModal";
import api from "../../services/api";
import { FaTrashAlt } from "react-icons/fa";
import { useEffect, useState } from "react";
import PageTitle from "../../components/PageTitle";

export default function PlansTable(props) {

  const [plans, setPlans] = useState([] as any);
  const [plan, setPlan] = useState({} as any);
  const [loading, setLoading] = useState(true);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [showPopUpDelete, setShowPopUpDelete] = useState(false);

  useEffect(() => {
    LoadPlans()
  }, []);

  async function LoadPlans() {
    try {
      setLoading(true)
      const result = await api.get(`/plans`);
      setPlans(result.data.plans);
      setLoading(false)
    }
    catch (error: any) {
      setLoading(false)
      setErrorMessage(error?.response?.data?.message);
    }
  }

  async function onDelete() {
    setLoading(true);
    try {
      const result = await api.delete(`/plans/${plan.id}`);
      if (result.data.success) {
        LoadPlans();
        setSuccessMessage("Planta deletada com sucesso!");
        onClosePopUp();
        setLoading(false);
      } else {
        setErrorMessage("Problema ao deletar a planta: " + result.data);
        onClosePopUp();
        setLoading(false);
      }
    } catch (error: any) {
      onClosePopUp();
      setLoading(false);
      setErrorMessage(error?.response?.data?.message);
    }
  }

  function onOpenPopUp(block) {
    setPlan(block);
    setShowPopUpDelete(true);
  }
  function onClosePopUp() {
    setShowPopUpDelete(false)
  }
  function onVariations(planId) {
    props.history.push(`/plans/${planId}`)
  }

  return (
    <Style>
      <PageTitle title="Plantas" />
      <TwoButtonsModal
        show={showPopUpDelete}
        onHide={onClosePopUp}
        loading={loading}
        title="Deleção de planta!"
        body={`Você está tentando deletar a planta "${plan.name}", essa ação é irreversível!`}
        secondaryText="Fechar"
        secondaryOnClick={onClosePopUp}
        secondaryDisabled={loading}
        primaryText="Deletar"
        primaryOnClick={onDelete}
        primaryDisabled={loading}
      />
      <Spinner spinning={loading} />
      <section className="table-title">
        <h1>Plantas</h1>
        <button onClick={() => props.history.push(`/plans/0`)}>Adicionar Planta</button>
      </section>
      {errorMessage && <p className="alert alert-error">Erro: {errorMessage}</p>}
      {successMessage && <p className="alert alert-info">{successMessage}</p>}
      <table className="table table-striped table-bordered table-hover main-table">
        <thead >
          <tr>
            <th>Nome</th>
            <th>Cena</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          {plans.length > 0 && plans.map(plan => {
            return (
              <tr key={plan.id}>
                <td onClick={() => onVariations(plan.id)}>{plan.name}</td>
                <td onClick={() => onVariations(plan.id)}>{plan.sceneName}</td>
                <td className="action">
                  <button onClick={() => onOpenPopUp(plan)}><FaTrashAlt className="icon" /></button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </Style>
  )
}